export default __webpack_public_path__ + "bfc04016f8d8e1508d21c1b492e37c16.png";